import {
  FamilyChildProfile,
  JoonUIColor,
  Loader,
  TextButton,
  Typography,
} from "@joonapp/web-shared"
import dayjs from "dayjs"

import { useQuestionnaireQuery } from "../../../networking/questionnaires/queries"
import { QuestionnaireAnswersResponse } from "../../../types"
import { getCurrentAge } from "../../../util/dates"
import useSurveysModalStore from "../store/useSurveysModalStore"

const getMostRecentSurveys = (
  surveys: QuestionnaireAnswersResponse[] | undefined
) => {
  if (!surveys) return []
  const mostRecentSurveys = {} as Record<string, QuestionnaireAnswersResponse>
  surveys.forEach((survey) => {
    const existingSurvey = mostRecentSurveys[survey.questionnaire.id]
    const isMoreRecent =
      survey.date_submitted &&
      existingSurvey?.date_submitted &&
      dayjs(survey.date_submitted).isAfter(dayjs(existingSurvey.date_submitted))

    if (!existingSurvey || isMoreRecent) {
      mostRecentSurveys[survey.questionnaire.id] = survey
    }
  })
  return Object.values(mostRecentSurveys)
}

const ChildSurveySectionItem = ({
  childProfile,
}: {
  childProfile: FamilyChildProfile
}) => {
  const { selectChildSurveys } = useSurveysModalStore()
  const { data: childSurveys, isLoading } = useQuestionnaireQuery(
    childProfile.user.id
  )

  const mostRecentSurveys = getMostRecentSurveys(childSurveys)

  const handleSelectSurvey = () => {
    if (!childSurveys) return
    selectChildSurveys({ surveys: mostRecentSurveys, profile: childProfile })
  }

  return (
    <div className="flex justify-between items-center border border-borderPrimary rounded-md px-3 py-1 min-h-12">
      <Typography variant="body">
        {childProfile.user.name}
        {childProfile.user.birthdate &&
          ` (${getCurrentAge(childProfile.user.birthdate)})`}
      </Typography>

      {isLoading ? (
        <Loader thickness={2} color={JoonUIColor.icon.light} size={16} />
      ) : childSurveys?.length && childSurveys.length > 0 ? (
        <TextButton onClick={handleSelectSurvey}>
          <Typography
            variant="bodySmall"
            color={JoonUIColor.text.primaryAccent}
          >
            View survey
          </Typography>
        </TextButton>
      ) : (
        <div className="pr-2">
          <Typography variant="bodySmall" color={JoonUIColor.text.secondary}>
            Not completed
          </Typography>
        </div>
      )}
    </div>
  )
}

export default ChildSurveySectionItem
